// hooks/useRequest.js
import { useState, useEffect } from 'react';
import { API_ROOT } from '../_helpers/constants';

export function useRequest(url, subresults = false) {
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let canceled = false;

    setLoaded(false);
    setError(null);

    const fetchData = async () => {
      try {
        const res = await fetch(API_ROOT + url);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const result = await res.json();
        if (!canceled) {
          setData(subresults ? result[subresults] : result);
          setLoaded(true);
        }
      } catch (err) {
        if (!canceled) {
          setError(err);
          setLoaded(true);
        }
      }
    };

    fetchData();

    return () => {
      canceled = true;
    };
  }, [url, subresults]);

  return { data, loaded, error };
}
